import { useContext } from "react";
import AppContext from "../contexts/AppContext";

export default () => {
  const context = useContext(AppContext);

  return context;
};